import { useState } from "react";
import { partnerStatusObject } from "../../../../utils/allProductStatus";
import Button from "../../../../atoms/button";


const PartnerStatusStep = ({ setStep, setProductData, productData }) => {

    const [status, setStatus] = useState(productData?.status || "GENERATED");

    const goBack = () => {
        setStep(2);
    }

    const handleSubmit = async () => {
        if(disableSubmit){
            return null;
        }
        setProductData(d => { return {...d, status} });
        setStep(4);
    }

    const disableSubmit = status === "";

    return (
        <div className="relative">
            <h2 className="text-lg border-t border-b border-primary py-2 mb-4">Status</h2>
            <p>Selecione o status do pedido ao ser criado</p>
            <select className="text-center text-black my-4" value={status} onChange={e => setStatus(e.target.value)}>
                <option value="">-</option>
                {
                    Object.keys(partnerStatusObject).map((o, i) => (
                        <option value={o} key={i}>{partnerStatusObject[o]}</option>
                    ))
                }
            </select>
            <div className="flex gap-4 w-fit m-auto">
                <Button click={goBack} classes="bg-purple-400 hover:bg-purple-300 mt-4">Voltar</Button>
                <Button click={handleSubmit} classes="bg-green-400 hover:bg-green-300 mt-4" disabled={disableSubmit}>Avançar</Button>
            </div>
        </div>
    )
}

export default PartnerStatusStep;

